import { handleMissingCookies } from 'utils';
import { MAIN, signups, signupTypes } from "utils/signup";
import SignUp from "@/components/layouts/SignUp/SignUp";

const SignUp2 = ({ stepRequested, type }) => {
    const signUpToShow = signups[type]
    return <SignUp stepRequested={stepRequested} content={signUpToShow} type={type} />
}

export async function getServerSideProps(context){
    const stepRequested = parseInt(context.query.step) > 0 ? parseInt(context.query.step) : 1
    const type = signupTypes.includes(context.query.type) ? context.query.type : MAIN
    return {
        props:{
            stepRequested,
            type
        }
    }
}

SignUp2.Nav = <></>

export default SignUp2;
